import { atom } from "jotai";

export const ModalStore = atom<{
  isOpen: boolean;
  onClose: () => any;
  children?: JSX.Element;
}>({ isOpen: false, onClose: () => {} });
